import axios from 'axios';
import apiConfig from '../../api.config';

var CancelToken = axios.CancelToken;
var cancel;

export default function bookingReportSendDelete(data) {
  const {
    host,
    URIs: { bookingReportDelete },
  } = apiConfig;

  const uri = `${host}${bookingReportDelete}`;

  if (cancel) cancel();

  return axios
    .delete(
      uri,
      { data },
      {
        headers: {
          'Content-Type': 'application/json',
        },
        cancelToken: new CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          cancel = c;
        }),
      }
    )
    .then(res => {
      return res.data;
    });
}
